import React from 'react'
import { ContentIcon, Logo } from './styles'
import BlurEffectLogo from 'src/assets/logos/logoBE.avif'
import { animationVariants } from 'src/theme/animations/swipeIn'

export function LogoComponent() {
    return (
        <ContentIcon to={'/'} aria-label="Read more about Seminole tax hike">
            <Logo
                src={BlurEffectLogo}
                alt={'logo'}
                initial="initial"
                animate="animate"
                variants={animationVariants}
            />
        </ContentIcon>
    )
}
